import { addMessages, init, getLocaleFromNavigator } from "svelte-i18n"
import { get } from "svelte/store"

import de from "./../locales/de.json"
import en from "./../locales/en.json"
import { location } from "./store"

addMessages("de", de)
addMessages("en", en)
export const locales = ["de", "en"]
export const fallbackLocale = "de"
export const localePattern = /^\/(de|en)(\/|$)/
function getLocale(): string {
    const loc = get(location)
    // check if already starts with one of locales
    if (loc.path.startsWith("/de")) return "de"
    if (loc.path.startsWith("/en")) return "en"

    return getLocaleFromNavigator() || fallbackLocale
}

export const navigatorLocale = getLocale()
export const initialLocale = navigatorLocale.replace(/\-.+$/, "")

init({
    fallbackLocale,
    initialLocale,
})

export function langField(field: any, _default?: any): any {
    if (field) {
        const prio = [initialLocale, "en", "de"]
        for (let i = 0; i < prio.length; i++) {
            if (field[prio[i]]) {
                return field[prio[i]]
            }
        }
    }
    return _default
}
